import type { MetaFunction } from "@remix-run/node";

export const meta: MetaFunction = () => {
  return [
    { title: "法律ブログ - 韓国法律実務情報 | 法務法人フィサン" },
    { name: "description", content: "韓国の国際離婚、相続、不動産、刑事事件に関する実務的な情報と実際のケーススタディ。日本人のための韓国法律解説ブログ。" },
    { name: "keywords", content: "韓国法律, 国際離婚, 離婚, 相続, 慰謝料, 養育費, 財産分与, 不動産, 刑事事件, 法律ブログ, 弁護士" },
    { property: "og:title", content: "法律ブログ - 韓国法律実務情報 | 法務法人フィサン" },
    { property: "og:description", content: "韓国の国際離婚、相続、不動産、刑事事件に関する実務的な情報と実際のケーススタディを提供します。" },
    { property: "og:type", content: "website" },
    { property: "og:url", content: "https://jp-hwisang.co.kr/ja/blog" },
    { property: "og:image", content: "https://jp-hwisang.co.kr/images/jp-hwisang-card.jpg" },
    { property: "og:locale", content: "ja_JP" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "robots", content: "index, follow" },
  ];
};

interface BlogArticle {
  title: string;
  url: string;
  category: "離婚・家事" | "その他";
}

const blogArticles: BlogArticle[] = [
  // 離婚・家事関連
  { title: "親権と養育費", url: "https://ameblo.jp/lawyergun/entry-12932056914.html", category: "離婚・家事" },
  { title: "慰謝料と財産分与", url: "https://ameblo.jp/lawyergun/entry-12932029884.html", category: "離婚・家事" },
  { title: "国際離婚、日本で離婚裁判ができるか", url: "https://ameblo.jp/lawyergun/entry-12931925669.html", category: "離婚・家事" },
  { title: "国際離婚、どちらの国の法律が適用される？", url: "https://ameblo.jp/lawyergun/entry-12931919887.html", category: "離婚・家事" },
  { title: "不倫の証拠を合法的に集める方法", url: "https://ameblo.jp/lawyergun/entry-12937320355.html", category: "離婚・家事" },
  { title: "離婚前に書いた財産分与に関する覚書の効力", url: "https://ameblo.jp/lawyergun/entry-12937673620.html", category: "離婚・家事" },
  { title: "SNSでDMを送っていたらストーカーの容疑をかけられた", url: "https://ameblo.jp/lawyergun/entry-12937831163.html", category: "離婚・家事" },
  { title: "姑の過干渉で離婚したい", url: "https://ameblo.jp/lawyergun/entry-12938011224.html", category: "離婚・家事" },
  { title: "別居中の配偶者から生活費をもらえない場合、どうすればいいでしょうか", url: "https://ameblo.jp/lawyergun/entry-12938061681.html", category: "離婚・家事" },
  { title: "責配偶者（不倫などをした）からの離婚請求は認められるのか？", url: "https://ameblo.jp/lawyergun/entry-12938193598.html", category: "離婚・家事" },
  { title: "不倫をしていまい、高額の慰謝料を請求された！", url: "https://ameblo.jp/lawyergun/entry-12934727640.html", category: "離婚・家事" },
  { title: "結婚前に取得した不動産も財産分与の対象になる？", url: "https://ameblo.jp/lawyergun/entry-12934743826.html", category: "離婚・家事" },
  { title: "韓国で違法な方法で集めた不倫の証拠は、裁判で使えない？", url: "https://ameblo.jp/lawyergun/entry-12934902687.html", category: "離婚・家事" },
  { title: "韓国における親権の具体的な内容", url: "https://ameblo.jp/lawyergun/entry-12935012938.html", category: "離婚・家事" },
  { title: "宝くじの当選金の財産分与の対象になるか", url: "https://ameblo.jp/lawyergun/entry-12935401717.html", category: "離婚・家事" },
  { title: "不倫をしても財産分与は認められる？", url: "https://ameblo.jp/lawyergun/entry-12935433130.html", category: "離婚・家事" },
  { title: "配偶者の愛人に対して慰謝料請求できる？", url: "https://ameblo.jp/lawyergun/entry-12935839667.html", category: "離婚・家事" },
  { title: "離婚したら相手の年金の半分もらえる？", url: "https://ameblo.jp/lawyergun/entry-12935860266.html", category: "離婚・家事" },
  { title: "相続の優先順位", url: "https://ameblo.jp/lawyergun/entry-1293566455.html", category: "離婚・家事" },
  { title: "経済力のない夫、離婚できますか？", url: "https://ameblo.jp/lawyergun/entry-12935992281.html", category: "離婚・家事" },
  { title: "財産分与を避けるため、勝手に財産を処分したらどうなる？", url: "https://ameblo.jp/lawyergun/entry-12936055549.html", category: "離婚・家事" },
  { title: "韓国で嫉妬妄想の配偶者との離婚は認められるか", url: "https://ameblo.jp/lawyergun/entry-12936091609.html", category: "離婚・家事" },
  { title: "간통죄（姦通罪）の廃止", url: "https://ameblo.jp/lawyergun/entry-12932864550.html", category: "離婚・家事" },
  { title: "アルコール依存症は離婚事由として認められるのか？", url: "https://ameblo.jp/lawyergun/entry-12933337259.html", category: "離婚・家事" },
  { title: "精神的な不倫は離婚事由になるか", url: "https://ameblo.jp/lawyergun/entry-12933438743.html", category: "離婚・家事" },
  { title: "韓国の離婚の原因、ベスト５", url: "https://ameblo.jp/lawyergun/entry-12933439424.html", category: "離婚・家事" },
  { title: "韓国で養育費を払わせる方法", url: "https://ameblo.jp/lawyergun/entry-12933734432.html", category: "離婚・家事" },
  { title: "養育費の減額、免除", url: "https://ameblo.jp/lawyergun/entry-12933743003.html", category: "離婚・家事" },
  { title: "韓国の離婚の種類はどんなものがありますか？", url: "https://ameblo.jp/lawyergun/entry-12933926036.html", category: "離婚・家事" },
  { title: "韓国における事実婚", url: "https://ameblo.jp/lawyergun/entry-12933932704.html", category: "離婚・家事" },
  { title: "仮想通過（暗号資産）と財産分与", url: "https://ameblo.jp/lawyergun/entry-12934083484.html", category: "離婚・家事" },
  { title: "離婚が成立した後、離婚相手の隠し財産が見つかったらどうなる？", url: "https://ameblo.jp/lawyergun/entry-12934355140.html", category: "離婚・家事" },

  // その他
  { title: "借主の原状回復義務、どこまで？", url: "https://ameblo.jp/lawyergun/entry-12934705442.html", category: "その他" },
  { title: "裁判で勝ったら相手に裁判費用を支払ってもらえるのでしょうか？", url: "https://ameblo.jp/lawyergun/entry-12935358311.html", category: "その他" },
  { title: "名誉毀損罪と侮辱罪との違い", url: "https://ameblo.jp/lawyergun/entry-12936099293.html", category: "その他" },
  { title: "반의사불벌죄（反意思不罰罪）", url: "https://ameblo.jp/lawyergun/entry-12932855539.html", category: "その他" },
  { title: "未払いの給料を請求する方法", url: "https://ameblo.jp/lawyergun/entry-12934061175.html", category: "その他" },
  { title: "借りている部屋のトイレの便器が壊れた！修理代は誰の負担？", url: "https://ameblo.jp/lawyergun/entry-12934362052.html", category: "その他" },
  { title: "不倫相手を家に入れたら住居侵入罪？", url: "https://ameblo.jp/lawyergun/entry-12935100946.html", category: "その他" },
];

export default function JapanBlog() {
  // カテゴリ別に記事を分類
  const divorceArticles = blogArticles.filter(article => article.category === "離婚・家事");
  const otherArticles = blogArticles.filter(article => article.category === "その他");

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
            <a href="/ja" className="flex items-center justify-center md:justify-start">
              <img src="/images/no-padding-logo.png" alt="法務法人フィサン" className="h-8 w-auto opacity-90" />
            </a>

            <div className="flex items-center justify-center md:justify-end gap-4 md:gap-6">
              <nav className="flex items-center gap-4 md:gap-6 text-sm">
                <a href="/ja/office" className="text-gray-700 hover:text-black whitespace-nowrap">事務所・所在地</a>
                <a href="/ja/services" className="text-gray-700 hover:text-black whitespace-nowrap">業務分野</a>
                <a href="/ja/blog" className="text-black font-medium whitespace-nowrap">法律ブログ</a>
              </nav>
              <a
                href="https://jp-hwisang.co.kr"
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 py-1.5 border border-gray-300 hover:border-gray-900 text-gray-700 hover:text-black text-sm transition-colors whitespace-nowrap"
              >
                한국어
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-5xl mx-auto">
          <a href="/ja" className="inline-flex items-center text-gray-500 hover:text-gray-900 mb-8 text-sm transition-colors">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            ホームに戻る
          </a>
          <div className="text-center">
            <h1 className="text-4xl font-serif mb-6 text-gray-900">
              法律ブログ
            </h1>
            <div className="w-16 h-px bg-gray-400 mx-auto mb-8"></div>
            <p className="text-lg text-gray-700 leading-relaxed">
              韓国法律に関する実務的な情報と実際のケーススタディをご紹介します。<br />
              離婚、相続、不動産、刑事事件など、様々な分野における法律問題について解説しています。
            </p>
          </div>
        </div>
      </section>

      {/* 離婚・家事事件 Section */}
      <section className="py-16 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="mb-12">
            <h2 className="text-2xl font-serif mb-4 text-gray-900 border-b-2 border-gray-200 pb-3">
              離婚・家事事件
            </h2>
            <p className="text-gray-600 text-sm">
              国際離婚、養育費、慰謝料、財産分与など、家事事件に関する記事
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {divorceArticles.map((article, index) => (
              <a
                key={index}
                href={article.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group block p-6 border border-gray-200 hover:border-gray-400 transition-all hover:shadow-md bg-white"
              >
                <div className="flex items-start justify-between">
                  <h3 className="text-base font-medium text-gray-900 group-hover:text-black leading-relaxed pr-4">
                    {article.title}
                  </h3>
                  <svg
                    className="w-5 h-5 text-gray-400 group-hover:text-black transition-colors flex-shrink-0 mt-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Divider */}
      <div className="w-24 h-px bg-gray-300 mx-auto my-8"></div>

      {/* その他 Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-5xl mx-auto">
          <div className="mb-12">
            <h2 className="text-2xl font-serif mb-4 text-gray-900 border-b-2 border-gray-200 pb-3">
              その他の法律問題
            </h2>
            <p className="text-gray-600 text-sm">
              不動産、刑事事件、労働問題など、様々な法律分野に関する記事
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {otherArticles.map((article, index) => (
              <a
                key={index}
                href={article.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group block p-6 border border-gray-200 hover:border-gray-400 transition-all hover:shadow-md bg-white"
              >
                <div className="flex items-start justify-between">
                  <h3 className="text-base font-medium text-gray-900 group-hover:text-black leading-relaxed pr-4">
                    {article.title}
                  </h3>
                  <svg
                    className="w-5 h-5 text-gray-400 group-hover:text-black transition-colors flex-shrink-0 mt-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl font-serif mb-6 text-gray-900">
            法律相談が必要ですか？
          </h2>
          <p className="text-gray-700 mb-8 leading-relaxed">
            韓国での法律問題でお困りの際は、お気軽にご相談ください。<br />
            日本語で丁寧に対応いたします。
          </p>
          <div className="space-y-3">
            <a
              href="mailto:mgkim@hwisang.co.kr"
              className="inline-block px-8 py-3 border border-gray-900 hover:bg-gray-900 hover:text-white text-gray-900 transition-colors"
            >
              お問い合わせ
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-50 border-t border-gray-200 py-12 px-4">
        <div className="max-w-5xl mx-auto text-center text-gray-600 text-sm">
          <p className="mb-2">法務法人 휘상（フィサン / 輝相）</p>
          <p className="mb-4">Seoul, Korea</p>
          <p>&copy; {new Date().getFullYear()} Law Firm Hwisang. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
